import React from "react";
import logo from "../../assets/logo.png";
import { useEffect } from "react";
import Typography from '@mui/material/Typography';
import "../../App.css";

import {properties} from "../../utils/properties";
import { useNavigate } from "react-router-dom";
import { textAlign } from "@mui/system";

export default function Login() {  
  const navigate = useNavigate();
  
  const handleClick = e => {
    e.preventDefault();    
    navigate("/reset");        
  };

  const handleClick2 = e => {
    e.preventDefault();    
    navigate("/login");        
  };

  const handleSubmit = e => {
    e.preventDefault();    
    if (!e.target.username.value) {
      window.alert("E' necessario inserire un indirizzo email valido formato: nome.cognome@compagniadisanpaolo.it");
    } else if (!e.target.password.value) {
      window.alert("E' necessario inserire la password utilizzata per accedere ai servizi della Fondazione");
    } else  
      {    
      doPost(e.target.username.value, e.target.password.value);            
    } 
  };

  const doPost2 = function() {
    if( properties.verboseLog==1)
      console.log("getting info");
    var xhr2 = new XMLHttpRequest();                    
    xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix+'/core/rest/getInfo6.php',true);    
    xhr2.withCredentials = true;
    xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    

    xhr2.onload = function (e) {
      if( properties.verboseLog==1)
        console.log("EEE",e,xhr2.readyState,xhr2.status);
      if (xhr2.readyState === 4) {
        if (xhr2.status === 200) {                              
          var responseText = xhr2.responseText;  
          if( properties.verboseLog==1)        
            console.log("OK LOGIN 33");          
          var obj=JSON.parse(responseText);  
          if( properties.verboseLog==1)
            console.log("GI6",obj);       
          localStorage.setItem("name", obj.Name);
          localStorage.setItem("genere", obj.Genere);
          localStorage.setItem("ruolo",obj.Ruolo);
          localStorage.setItem("indice",obj.Indice);          
          if(obj.CommandsCommissioni!=undefined && obj.CommandsCommissioni!=null){
            if( properties.verboseLog==1)
              console.log("obj.commandsCommissioni",obj.CommandsCommissioni);
            localStorage.setItem("commandsCommissioni", JSON.stringify(obj.CommandsCommissioni));
          }          
          localStorage.setItem("commandsGeneral", JSON.stringify(obj.CommandsGeneral));          
          localStorage.setItem("commandsComitato", JSON.stringify(obj.CommandsComitato));          
          localStorage.setItem("commandsConsiglio", JSON.stringify(obj.CommandsConsiglio));          
          localStorage.setItem("commandsCollegio", JSON.stringify(obj.CommandsCollegio));          
          localStorage.setItem("commandsComitatoInvestimenti", JSON.stringify(obj.CommandsComitatoInvestimenti));          
        } else {            
          console.error("Error 13", xhr2.statusText);                  
          window.alert("Errore recuperando info utente");  
        }
      }
    };
    
    xhr2.onerror = function (e) {
      console.error("Error 43", xhr2.statusText);
    };
             
    let urlEncodedData = null; 
    xhr2.send(urlEncodedData);
}

  const doPost = function(user, pwd) {
    localStorage.clear();
    if( properties.verboseLog==1){
      console.log("doing first post");
      console.log("NOVEL2",Document.referrer);
    }
    var xhr = new XMLHttpRequest();                    
    xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix+'/core/login2.php',true);   
    xhr.withCredentials = true; 
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

    xhr.onload = function (e) {    
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {         
        if(!window.cordova){           
          doPost2();
        }
        else {
        localStorage.setItem("name", "Alberto");      
        localStorage.setItem("genere", "1");              
        }          
        if( properties.verboseLog==1)
          console.log("NOVEL",Document.referrer);        
        navigate("/init");
        } else {
          console.error("Error 63", xhr.statusText);          
          window.alert("Login fallito: Username o password errati! Riprovare o contattare l'amministratore");  
        }
      }
    };
        
    xhr.onerror = function (e) {
      console.error("Error 93", xhr.statusText);
    };
             
    let urlEncodedData = "user=" + user + "&password=" + pwd; 
    xhr.send(urlEncodedData);
  }

  useEffect(() => {
        if( properties.verboseLog==1){
          console.log("Q1",Document.referrer);
          console.log("Q2",Document);
        }
        if(localStorage.getItem("ruolo")!=null) {        
          navigate("/init");
        }          
  }, []);

  return (
    <div className="content" style = {{alignItems: "center", display: "flex", height: "100%",  justifyContent: "center"}}>
      <div className="AppLogin" style={{backgroundColor:"#ffffff"}}>
        <img src={logo} className="logo1" alt="Logo" />
        <form className="form1" onSubmit={handleSubmit} >
        <div className="input-group">
            <label> Accesso tramite credenziali aziendali </label>                      
        </div>
          <div className="input-group">
            <label htmlFor="username">E-mail </label>
            <input type="username" name="username" placeholder="nome.cognome@compagniadisanpaolo.it" />
          </div>
          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input type="password" name="password" placeholder="*******"/>
          </div>
          <button className="button12">Accedi</button>
          
          <div style = {{alignItems: "center", marginTop:"15px",marginBottom:"15px", display: "flex", height: "100%",  justifyContent: "center"}}>          
            <hr style={{margin:"20px", marginLeft:"40px", marginRight:"40px", width:"35%", borderTop: "3px solid #E6E6E6", borderRadius: "5px"}} ></hr>
          oppure
            <hr style={{margin:"20px", marginLeft:"40px", marginRight:"40px", width:"35%", borderTop: "3px solid #E6E6E6", borderRadius: "5px"}} ></hr>
          </div>
          <button className="button11"  onClick={handleClick2}> 
            Accedi con credenziali Fascicolo Digitale</button>
        </form>
       
      </div>
      </div>
  );
  
  }  
